<div class="relative text-slate-200 hover:cursor-default">
    <div #selectElement (click)="onSelectClicked($event)" class="flex flex-row gap-1 text-xs md:text-sm bg-ponder w-full p-1 pb-[5px] border border-ponder-bright overflow-x-hidden" [ngClass]="{ 'border-transparent' : !dropdownVisible }">
        <div>Mana</div>
    </div>
    <div class="absolute min-w-[20ch] w-full max-h-[300px] z-30 overflow-y-auto bg-ponder border border-faded-10 shadow" [ngClass]="{ 'hidden' : !dropdownVisible }">
        <div class="flex flex-col">
            <div (click)="onAllClicked($event)" class="flex flex-row gap-2 p-2 pb-1 pt-1 hover:bg-ponder-linkhover">
                <input #allOption type="checkbox">
                <div>All</div>
            </div>
            <div (click)="onColorClicked(none, $event)" class="flex flex-row gap-2 p-2 pb-1 pt-1 group hover:bg-ponder-linkhover" [ngClass]="{'text-faded-50 hover:bg-transparent' : !none.count }">
                <input #noneOption type="checkbox" [disabled]="!none.count">
                <div>None ({{ none.count }})</div>
            </div>
            <div (click)="onColorClicked(white, $event)" class="flex flex-row gap-2 p-2 pb-1 pt-1 group hover:bg-ponder-linkhover" [ngClass]="{'text-faded-50 hover:bg-transparent' : !white.count }">
                <input #whiteOption type="checkbox" [disabled]="!white.count">
                <div class="symbol-magic" style="background-image: url('https://images.pondertcg.com/magic/symbol/W.svg');"></div>
                <div>White ({{ white.count }})</div>
            </div>
            <div (click)="onColorClicked(blue, $event)" class="flex flex-row gap-2 p-2 pb-1 pt-1 group hover:bg-ponder-linkhover" [ngClass]="{'text-faded-50 hover:bg-transparent' : !blue.count }">
                <input #blueOption type="checkbox" [disabled]="!blue.count">
                <div class="symbol-magic" style="background-image: url('https://images.pondertcg.com/magic/symbol/U.svg');"></div>
                <div>Blue ({{ blue.count }})</div>
            </div>
            <div (click)="onColorClicked(black, $event)" class="flex flex-row gap-2 p-2 pb-1 pt-1 group hover:bg-ponder-linkhover" [ngClass]="{'text-faded-50 hover:bg-transparent' : !black.count }">
                <input #blackOption type="checkbox" [disabled]="!black.count">
                <div class="symbol-magic" style="background-image: url('https://images.pondertcg.com/magic/symbol/B.svg');"></div>
                <div>Black ({{ black.count }})</div>
            </div>
            <div (click)="onColorClicked(red, $event)" class="flex flex-row gap-2 p-2 pb-1 pt-1 group hover:bg-ponder-linkhover" [ngClass]="{'text-faded-50 hover:bg-transparent' : !red.count }">
                <input #redOption type="checkbox" [disabled]="!red.count">
                <div class="symbol-magic" style="background-image: url('https://images.pondertcg.com/magic/symbol/R.svg');"></div>
                <div>Red ({{ red.count }})</div>
            </div>
            <div (click)="onColorClicked(green, $event)" class="flex flex-row gap-2 p-2 pb-1 pt-1 group hover:bg-ponder-linkhover" [ngClass]="{'text-faded-50 hover:bg-transparent' : !green.count }">
                <input #greenOption type="checkbox" [disabled]="!green.count">
                <div class="symbol-magic" style="background-image: url('https://images.pondertcg.com/magic/symbol/G.svg');"></div>
                <div>Green ({{ green.count }})</div>
            </div>
            <div (click)="onColorClicked(colorless, $event)" class="flex flex-row gap-2 p-2 pb-1 pt-1 group hover:bg-ponder-linkhover" [ngClass]="{'text-faded-50 hover:bg-transparent' : !colorless.count }">
                <input #colorlessOption type="checkbox" [disabled]="!colorless.count">
                <div class="symbol-magic" style="background-image: url('https://images.pondertcg.com/magic/symbol/C.svg');"></div>
                <div>Colorless ({{ colorless.count }})</div>
            </div>
            <div class="border-t h-[1px] border-faded-05 m-1"></div>
            <div class="grid grid-cols-2">
                <div (click)="onOrClicked($event)" class="flex flex-row gap-2 p-2 pb-1 pt-1 group hover:bg-ponder-linkhover">
                    <input #orOption type="checkbox">
                    <div>OR</div>
                </div>
                <div (click)="onAndClicked($event)" class="flex flex-row gap-2 p-2 pb-1 pt-1 group hover:bg-ponder-linkhover">
                    <input #andOption type="checkbox">
                    <div>AND</div>
                </div>
            </div>
        </div>
    </div>
</div>